<template>
  <div>
    <breadcrumb :list="breadcrumbList"></breadcrumb>
    <el-card class="range_box">
      <div class="subject">
        <el-row type="flex" class="subject_title">
          <img src="@/assets/img/tag.png" alt="" />
          <span class="title_text">设置打卡范围</span>
        </el-row>
        <div>
          <el-row>
            <el-col :xs="12" :sm="12" :md="12" :lg="16" :xl="16">
              <el-form ref="form" :model="form" label-width="auto" class="form">
                <el-row>
                  <el-col :xs="24" :sm="23" :md="23" :lg="8">
                    <el-form-item label="请设置打卡范围：" prop="range">
                      <el-input
                        v-model="form.range"
                        size="medium"
                        @input="handleBlur"
                      >
                        <i slot="suffix" class="zzdw">m </i>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div>当前企业地址：{{ form.cs_dzmc }}</div>
            </el-col>
            <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
              <img
                style="margin-top:-110px"
                src="../../../assets/img/bg.png"
                alt=""
              />
            </el-col>
          </el-row>

          <div
            id="container"
            style="width:100%;height:550px;position: absolute;margin-top: -160px;"
            v-if="show"
          >
            <tdt-map :center="marker1" :zoom="zoom">
              <tdt-marker :position="marker1"></tdt-marker>
              <tdt-circle
                :center="marker1"
                :radius="radius"
                color="#3077ff"
                :opacity="1"
              ></tdt-circle>
            </tdt-map>
          </div>
          <!-- </el-row> -->
          <!-- <div style="margin-top: -150px;position: relative;">
            <div
              id="container"
              style="width:100%;height:550px;position: absolute;"
            ></div>
          </div> -->
          <div style="position:absolute;left:50%;bottom:0">
            <el-button class="change" type="primary" @click="submitRange"
              >确认</el-button
            >
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script
  type="text/javascript"
  src="https://webapi.amap.com/maps?v=1.4.15&key=b0cc045d3960ef69c2ea4619521f03e1&plugin=AMap.Geocoder"
></script>
<script>
import * as user from '@/api/user'
// import NoTime from './components/no_time.vue'
import Breadcrumb from '@/components/breadcrumb'
// import { filtersInfo, lists } from '@/utils/dictionary.js'
import AMapLoader from '@amap/amap-jsapi-loader'
import coordtransform from 'coordtransform'
export default {
  name: 'EnterpriseInformationIndex',
  components: { Breadcrumb },
  data() {
    return {
      center: null,
      zoom: 13,
      marker1: null,
      radius: 300,
      imgList: [],
      show: false,
      breadcrumbList: [
        // 面包屑所需数据
        { name: '人员日志', path: 'per_log' },
        { name: '设置打卡范围', path: 'per_log/set_range' }
      ],
      form: {
        range: '',
        cs_dzmc: '',
        cs_dzjd: '',
        cs_dzwd: ''
      },
      map: '',
      circle: ''
    }
  },
  async created() {
    await this.info()
    // await this.initAMap()
  },
  methods: {
    async info() {
      // 总数据
      const res = await user.getEnterpriseDetails(
        this.$store.state.user.userInfo.place_id
      )
      console.log('res', res)
      this.form = res
      console.log(coordtransform.gcj02towgs84(res.cs_dzjd, res.cs_dzwd))
      this.marker1 = [res.cs_dzjd, res.cs_dzwd]
      this.radius = res.range
      this.form.range = res.range
      setTimeout(() => {
        this.show = true
      }, 200)
    },
    //  initAmap(){
    //       useApiLoader({
    //         v: "4.0",
    //         tk: "f05e9ec66c7f541b1e87a84896e0de20",
    //         plugins: ["D3", "CarTrack", "HeatmapOverlay", "BufferTool", "ImageOverLayer"]
    //       }).then(() => {
    //         const map = new T.Map("container");
    //         map.centerAndZoom(new T.LngLat(108.949632, 34.268927), 12);
    //         const marker = new T.Marker(new T.LngLat(108.949632, 34.268927));
    //         map.addOverlay(marker);
    //       });
    //  },

    // initAMap() {
    //   setTimeout(() => {
    //     this.map = new AMap.Map('container', {
    //       resizeEnable: true,
    //       zoom: 17,
    //       center: [this.form.cs_dzjd, this.form.cs_dzwd]
    //       // center: [116.397428, 39.90923], // 地图中心点
    //     })
    //     // 禁止拖拽
    //     AMap.event.addListener(this.map, 'dragstart', () => {
    //       this.map.setStatus({ dragEnable: false })
    //     })
    //     this.marker = new AMap.Marker({
    //       position: [this.form.cs_dzjd, this.form.cs_dzwd],
    //       map: this.map,
    //       icon: require('@/assets/img/mark.png')
    //     })
    //     var circle = new AMap.Circle({
    //       map: this.map,
    //       center: new AMap.LngLat(this.form.cs_dzjd, this.form.cs_dzwd), // 圆心坐标
    //       // radius: 1000, // 半径，单位米
    //       radius: this.form.range, // 半径，单位米
    //       strokeColor: 'rgba(100,71,213, 1)', // 线颜色
    //       strokeWeight: 1, // 线宽
    //       strokeStyle: 'dashed', // 线样式
    //       strokeOpacity: 0.5, // 线透明度
    //       fillColor: 'rgba(98, 69, 213, 0.3)', // 填充颜色
    //       fillOpacity: 0.2 // 填充透明度
    //     })
    //     this.map.add(circle)
    //     this.map.add(marker)
    //   })
    // },
    handleBlur() {
      console.log('range', this.form.range)
      this.radius = this.form.range
      // this.initAMap()
    },
    submitRange() {
      const res = user
        .setEnterpriseRange({ range: this.form.range })
        .then(() => {
          let code = sessionStorage.getItem('requestCode')
          let msg = sessionStorage.getItem('successTip')

          if (code == 0) {
            this.$message.success(msg)
            this.$router.push('/per_log')
          } else {
            this.$message.error(msg)
          }
        })
    },

    // initMap() {
    //   // 高德地图SDK初始化
    //   const map = new AMap.Map('map', {
    //     zoom: 15, // 缩放级别
    //     center: [116.397428, 39.90923] // 中心点坐标
    //   })

    //   // 创建圆形编辑器
    //   const circleEditor = new AMap.CircleEditor(map, {
    //     radius: 1000, // 圆的半径，单位米
    //     strokeColor: 'blue', // 圆边线颜色
    //     strokeWeight: 3, // 圆边线宽度
    //     fillColor: 'rgba(0,0,255,0.3)' // 圆填充颜色
    //   })

    //   // 创建圆
    //   const lnglats = [
    //     [116.389288, 39.90923], // 圆心坐标
    //     [116.397428, 39.90923] // 圆周上的另一点，可以是圆周上的任意点
    //   ]
    //   circleEditor.on('add', event => {
    //     // 当编辑器添加圆后的回调
    //     console.log('Circle added:', event.target)
    //   })

    //   // 绘制圆
    //   circleEditor.render(lnglats)
    // },

    goBack() {
      //返回
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.range_box {
  margin: 20px;
  padding: 20px;
  //   background-image: url();
  //   background: url(../../../assets/img/bg.png) no-repeat;
  //   height: 100%;
  //   background-size: 50% 50%;
  //   width: 100%;
  /deep/.el-input__suffix-inner {
    border-left: 1px solid rgba(193, 192, 208, 1);
    padding-left: 5px;
  }
  .zzdw {
    margin-right: 12px;
    font-size: 12px;
    // color: #6345d5;
    color: rgba(37, 40, 44, 1);
    font-style: normal;
  }
  .subject {
    height: 750px;
    position: relative;
    .subject_title {
      //   padding: 32px 0 15px 0;

      img {
        width: 30px;
        height: 39px;
        margin-right: 3px;
      }

      .title_text {
        font-size: 18px;
        line-height: 36px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #6345d5;
      }
    }
  }
}
</style>
